/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './admission-advice.reducer';

export const AdmissionAdviceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const admissionAdviceEntity = useAppSelector(state => state.admissionAdvice.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="admissionAdviceDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.admissionAdvice.detail.title">AdmissionAdvice</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.id">Id</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.id}</dd>
          <dt>
            <span id="procedureSNId">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.procedureSNId">Procedure SN Id</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.procedureSNId}</dd>
          <dt>
            <span id="procedureSNText">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.procedureSNText">Procedure SN Text</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.procedureSNText}</dd>
          <dt>
            <span id="adviseNotes">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.adviseNotes">Advise Notes</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.adviseNotes}</dd>
          <dt>
            <span id="instructions">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.instructions">Instructions</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.instructions}</dd>
          <dt>
            <span id="snomedConceptId">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.snomedConceptId">Snomed Concept Id</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.snomedConceptId}</dd>
          <dt>
            <span id="snomedConceptText">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.snomedConceptText">Snomed Concept Text</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.snomedConceptText}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.active">Active</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.cursor}</dd>
          <dt>
            <span id="fulfilled">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.fulfilled">Fulfilled</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.fulfilled ? 'true' : 'false'}</dd>
          <dt>
            <span id="emergency">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.emergency">Emergency</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.emergency ? 'true' : 'false'}</dd>
          <dt>
            <span id="highRisk">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.highRisk">High Risk</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.highRisk ? 'true' : 'false'}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.modifiedByID}</dd>
          <dt>
            <span id="emAdmissionId">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.emAdmissionId">Em Admission Id</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.emAdmissionId}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.type">Type</Translate>
            </span>
          </dt>
          <dd>{admissionAdviceEntity.type}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.admissionAdvice.proposedProcedure">Proposed Procedure</Translate>
          </dt>
          <dd>{admissionAdviceEntity.proposedProcedure ? admissionAdviceEntity.proposedProcedure.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.admissionAdvice.diagnosis">Diagnosis</Translate>
          </dt>
          <dd>{admissionAdviceEntity.diagnosis ? admissionAdviceEntity.diagnosis.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.admissionAdvice.appointment">Appointment</Translate>
          </dt>
          <dd>{admissionAdviceEntity.appointment ? admissionAdviceEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.admissionAdvice.advicedBy">Adviced By</Translate>
          </dt>
          <dd>{admissionAdviceEntity.advicedBy ? admissionAdviceEntity.advicedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.admissionAdvice.patient">Patient</Translate>
          </dt>
          <dd>{admissionAdviceEntity.patient ? admissionAdviceEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.admissionAdvice.admitAt">Admit At</Translate>
          </dt>
          <dd>{admissionAdviceEntity.admitAt ? admissionAdviceEntity.admitAt.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/admission-advice" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/admission-advice/${admissionAdviceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AdmissionAdviceDetail;
